// extracted by mini-css-extract-plugin
export default {"error":"animations-module--error--1yYdj","success":"animations-module--success--npb7p","waiting":"animations-module--waiting--fZQnU","wiggle":"animations-module--wiggle--355Ak"};